import useCachedList from '../base/useCachedList';
import useFindHospitalsVisibleLazy from './useFindHospitalsVisible';

const useCachedHospitalList = () => {
  return useCachedList('hospitalList', useFindHospitalsVisibleLazy);
};

export default useCachedHospitalList;
